<template>
  <b-container>
    <Breadcrumbs crumbString="Products,Specialty Items"></Breadcrumbs>
    <b-row>
      <b-col class="col-12 col-md-4 col-lg-4">
        <h2>{{ title }}</h2>
        <div>
          Specialty sign applications
        </div><br>
        <div>
          Following are examples of a wide variety of non-typical sign applications. Interpretive
          GRAPHICS/enviroSIGNS has a long history of adapting to very specific communication challenges.
        </div>
        <div><b-btn class="mt-3" @click="createEstimateFromPage">Create an Estimate</b-btn></div>
      </b-col>
      <b-col class="col-12 col-md-8 col-lg-8">
        <b-container class="pods-container">
          <b-row>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <div class="img specialty-items-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/specialty-items/flat-cut-anodized-aluminum-letters.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-5 col-md-5 image-pod">
              <div class="img specialty-items-113-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/specialty-items/banners.jpg') + ')'}"></div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-12 col-md-5 col-lg-5 image-pod">
              <div class="img specialty-items-170-img"
                   v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/specialty-items/custom-anodized-aluminum-signs.jpg') + ')'}"></div>
            </b-col>
            <b-col class="col-12 col-md-7 col-lg-7 image-pod">
              <b-row>
                <b-col>
                  <div class="img specialty-items-60-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/specialty-items/interactive-flip-panel-interpretive-sign.jpg') + ')'}"></div>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <div class="img specialty-items-57-img"
                       v-bind:style="{backgroundImage: 'url(' + require('@/assets/images/pages/specialty-items/interactive-rotating-interpretive-signs.jpg') + ')'}"></div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs.vue'
  import { createEstimateFromPage } from '@/mixins/createEstimateFromPage'

  export default {
    components: {
      Breadcrumbs
    },
    mixins: [ createEstimateFromPage ],
    data () {
      return {
        title: 'Specialty Items'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/products/SpecialtyItems.vue